<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Split_Lot_Items_Title' | translateWF: 'Split Lot Items' }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetail()" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (dataSource.length > 0) {
        <!-- Filters Panel -->
        @if (showFilters()) {
          <p-panel header="Filters">
            <p-card data-variant="flat">
              <form [formGroup]="filtersForm" (ngSubmit)="loadTableData()">
                <div class="form-box">
                  <label>{{ 'Split_Lot_Items_Split_Lot_Item_ID' | translateWF: 'Split Lot Item ID' }}</label>
                  <input pInputText type="text" class="w-full" formControlName="lotId" />
                </div>

                <div class="form-box">
                  <label>{{ 'Split_Lot_Items_Lot_Item_Splited' | translateWF: 'Lot Item Split' }}</label>
                  <input pInputText type="text" class="w-full" formControlName="lotItemSplited" />
                </div>

                <div class="row mt-6">
                  <p-button [label]="'Common_Reset' | translateWF: 'Reset'" variant="outlined" class="w-full" [styleClass]="'w-full'" (click)="resetFilters()" />
                  <p-button [label]="'Common_Apply' | translateWF: 'Apply'" class="w-full" [styleClass]="'w-full'" (click)="loadTableData()" />
                </div>
              </form>
            </p-card>
          </p-panel>
        }

        <!-- Table Panel -->
        <p-panel [header]="'Split_Lot_Items' | translateWF: 'Split Lot Items'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
              [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
              (click)="showFilters.set(!showFilters())"
              variant="outlined"
              size="small"
            />
          </ng-template>
          <p-card data-variant="compact">
            <p-table [value]="dataSource" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" selectionMode="single">
              <ng-template #header>
                <tr>
                  <th>{{ 'Split_Lot_Items_Split_Lot_Item_ID' | translateWF: 'Split Lot Item ID' }}</th>
                  <th>{{ 'Split_Lot_Items_Lot_Item_Splited' | translateWF: 'Lot Item Split' }}</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template #body let-item>
                <tr class="cursor-pointer" (click)="redirectToDetail(item.id)">
                  <td>
                    <a>{{ item.id }}</a>
                  </td>
                  <td>{{ item.providerLotId }}</td>
                  <td class="!text-end">
                    <p-button icon="pi pi-pencil" variant="text" (onClick)="redirectToDetail(item.id)" />
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </p-panel>
      } @else {
        <div>
          <p-message class="flex space-between max-w-[320px]" severity="secondary"
            >{{ 'Split_Lot_Items_Lot_Item_No_Found' | translateWF: 'No Lot Item Found' }}
            <p-button class="ml-2" [label]="'Common_Add' | translateWF: 'Add'" (click)="redirectToDetail()" />
          </p-message>
        </div>
      }
    </div>
  </div>
</main>

<p-toast position="top-center" />
